import {useEffect, useRef} from '@wordpress/element';
import {ensureErrorResponse, ensureSuccessResponse} from "../utils";
import {useThreeDSecure} from "./use-three-d-secure";
import {useDeviceData} from "./use-device-data";
import {usePaymentMethodDataContext} from '../context';

export const useProcessPayment = (
    {
        name,
        billing,
        gatewayId,
        useFastlane = false,
        shippingData,
        responseTypes,
        onPaymentSetup,
        activePaymentMethod,
        advancedFraudOptions = {}
    }) => {
    const currentData = useRef({shippingData, billing, name, gatewayId, activePaymentMethod});
    const {
        paymentMethodData,
        doPaymentDataFilter
    } = usePaymentMethodDataContext();

    useThreeDSecure({name, gatewayId, skip: useFastlane});

    useDeviceData(advancedFraudOptions);

    useEffect(() => {
        currentData.current = {
            shippingData,
            billing,
            name,
            gatewayId,
            activePaymentMethod,
            paymentMethodData
        };
    });

    useEffect(() => {
        const unsubscribe = onPaymentSetup(async () => {
            if (currentData.current.activePaymentMethod == currentData.current.name) {
                try {
                    const nonceKey = `${gatewayId}_nonce_key`;
                    const {paymentMethodData} = currentData.current;

                    let response = {
                        meta: {
                            paymentMethodData: {
                                [nonceKey]: paymentMethodData?.nonce || ''
                            }
                        },
                        ...paymentMethodData
                    }

                    response = await doPaymentDataFilter(response, {nonceKey, ...currentData.current});

                    // clean up the response since it could be carrying data passed between filters.
                    response = {
                        meta: {
                            ...response.meta
                        }
                    }

                    return ensureSuccessResponse(responseTypes, response);
                } catch (error) {
                    return ensureErrorResponse(responseTypes, error);
                }
            }
        });
        return () => unsubscribe();
    }, [
        gatewayId,
        onPaymentSetup,
        doPaymentDataFilter,
    ]);
}

export default useProcessPayment;